"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var Avatar = props => {
  var classes = (0, _styles.default)(props);
  var {
    username,
    imageProps,
    variant
  } = props;
  var className = classes.avatarImage;
  if (variant === 'large') className = (0, _clsx.default)(classes.avatarImage, classes.large);else if (variant === 'medium') className = (0, _clsx.default)(classes.avatarImage, classes.medium);else if (variant === 'small') className = (0, _clsx.default)(classes.avatarImage, classes.small);else if (variant === 'x-small') className = (0, _clsx.default)(classes.avatarImage, classes['x-small']);
  return /*#__PURE__*/_react.default.createElement(_Avatar.default, _extends({
    className: className
  }, imageProps), username[0].toUpperCase());
};
var _default = exports.default = Avatar;